export class SubsidyPartner {
	id?: number;
	name: string;
	role: string;
	description: string;

	constructor(obj: any = {}) {
		this.id = obj.id;
		this.name = obj.name;
		this.role = obj.role;
		this.description = obj.description;
	}
}
